import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const generateCode = () => Math.random().toString(36).substring(2, 8).toUpperCase();

export function useReferral() {
  const [code, setCode] = useState<string | null>(null);
  const [referrals, setReferrals] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setLoading(false); return; }

      let { data: existing } = await supabase
        .from("referral_codes")
        .select("code")
        .eq("user_id", user.id)
        .maybeSingle();

      if (!existing) {
        const newCode = generateCode();
        const { data: inserted } = await supabase
          .from("referral_codes")
          .insert({ user_id: user.id, code: newCode })
          .select("code")
          .single();
        existing = inserted;
      }
      setCode(existing?.code ?? null);

      const { data: refs } = await supabase
        .from("referrals")
        .select("*")
        .eq("referrer_id", user.id)
        .order("created_at", { ascending: false });
      setReferrals(refs ?? []);
      setLoading(false);
    })();
  }, []);

  return { code, referrals, loading };
}
